import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { storageKeys } from 'config/settings.json';
import StorageHandler from 'config/StorageHandler';

export interface ConfirmImpersonationInput {
  token: string;
  email: string;
  user: Record<string, unknown>;
}

/** Commits a previewed impersonation: swaps the active accessToken/user and marks impersonation active. */
export function useConfirmImpersonation(): UseMutationResult<void, Error, ConfirmImpersonationInput> {
  return useMutation({
    mutationFn: ({ token, email, user }: ConfirmImpersonationInput): Promise<void> => {
      StorageHandler.save(storageKeys.accessToken, token);
      StorageHandler.save(storageKeys.user, user);
      StorageHandler.save(storageKeys.impersonationState, {
        active: true,
        email,
        startedAt: new Date().toISOString(),
      });
      return Promise.resolve();
    },
  });
}
